import type { CSSProperties } from 'react'

export type ScreenLoaderSize = 'sm' | 'md' | 'lg'

export const SCREEN_LOADER_SIZES: ScreenLoaderSize[] = ['sm', 'md', 'lg']

export const SCREEN_LOADER_SIZE_LABELS: Record<ScreenLoaderSize, string> = {
  sm: 'Small',
  md: 'Medium',
  lg: 'Large',
}

/** Rem height for the Enamel tooth mark. */
export const SCREEN_LOADER_SIZE_REMS: Record<ScreenLoaderSize, number> = {
  sm: 4,
  md: 6,
  lg: 8,
}

export type ScreenLoaderProps = {
  /** When false, nothing is rendered. Defaults to true. */
  open?: boolean
  /**
   * Portal target. Defaults to `document.body`.
   * Pass a page/module container to scope the overlay (legacy GlobalLoading).
   */
  container?: HTMLElement | null
  /** Preset mark size. Ignored when `height` is set. */
  size?: ScreenLoaderSize
  /** Custom mark height in rem (legacy `LoadingIndicator` API). */
  height?: number
  /**
   * Render inside the parent instead of a portal (showcase / inline demos).
   * Uses absolute positioning within a relative parent.
   */
  inline?: boolean
  /** Skip portal even when not inline (render in place as fixed overlay). */
  portal?: boolean
  className?: string
  style?: CSSProperties
  'aria-label'?: string
}
